module.exports = __webpack_public_path__ + "img/List_Line_16px_Icon_0.6.67890d44.svg";